export interface ApiErrorInfo {
  detail?: string;
  desc?: string;
}

interface ApiErrorLike {
  detail?: unknown;
  desc?: unknown;
  response?: { data?: { desc?: unknown; detail?: unknown } };
}

// Ошибки artemy приходят двумя способами: LunaError раскладывает desc/detail
// на верхний уровень, обычный axios-объект — в response.data.
export function getApiErrorInfo(error: unknown): ApiErrorInfo {
  const apiError = error as ApiErrorLike;

  let detail: string | undefined;
  if (typeof apiError?.detail === 'string') {
    detail = apiError.detail;
  } else if (typeof apiError?.response?.data?.detail === 'string') {
    detail = apiError.response.data.detail;
  }

  let desc: string | undefined;
  if (typeof apiError?.desc === 'string') {
    desc = apiError.desc;
  } else if (typeof apiError?.response?.data?.desc === 'string') {
    desc = apiError.response.data.desc;
  }

  return { detail, desc };
}
